import axios from "axios";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const KeepSessionService = {
    keepSession: async () => axios.post(API_KEEPER + "/keep-session").then(({data}) => data).catch((err) => { throw err }),

    notificationsCount: async () => axios.get(API_KEEPER + "/notifications/count").then(({data}) => data).catch((err) => { throw err }),

    individualAlarmHasEvents: async () => axios.get(API_KEEPER + "/individual/alarm/hasEvents").then(({data}) => data).catch((err) => { throw err }),
};

export default KeepSessionService;
